export default __webpack_public_path__ + "static/media/dev.f571eb54.jpeg";